__turbopack_context__.v({
  "cellIcon": "MobileComparison-module__unt8eG__cellIcon",
  "cellIconCheck": "MobileComparison-module__unt8eG__cellIconCheck",
  "cellIconCross": "MobileComparison-module__unt8eG__cellIconCross",
  "cellText": "MobileComparison-module__unt8eG__cellText",
  "divider": "MobileComparison-module__unt8eG__divider",
  "groupColumnHeader": "MobileComparison-module__unt8eG__groupColumnHeader",
  "groupColumnHeaderCol": "MobileComparison-module__unt8eG__groupColumnHeaderCol",
  "groupRows": "MobileComparison-module__unt8eG__groupRows",
  "groupSectionTitle": "MobileComparison-module__unt8eG__groupSectionTitle",
  "root": "MobileComparison-module__unt8eG__root",
  "row": "MobileComparison-module__unt8eG__row",
  "rowIntro": "MobileComparison-module__unt8eG__rowIntro",
  "rowLabel": "MobileComparison-module__unt8eG__rowLabel",
  "rowValue": "MobileComparison-module__unt8eG__rowValue",
  "rowValues": "MobileComparison-module__unt8eG__rowValues",
});
